import { Injectable } from "@angular/core";
import { UserDTO } from "../auth/User";
import { AccountAppDTO } from "../apps/AccountApp";
import { FacilityDTO } from "../facilities/Facility";
import { AvailableAccount } from "../accounts/AvailableAccount";
import { SessionService } from "../session.service";

@Injectable({
  providedIn: "root",
})
export class LocalStorageService {
  constructor(
  ) {}

  get authToken() {
    return localStorage.getItem("auth_token");
  }

  set accountID(accountID: string) {
    localStorage.setItem("account_id", accountID);
  }

  get accountID(): string {
    return localStorage.getItem("account_id") as string;
  }

  get appID(): number {
    return Number.parseInt(localStorage.getItem("app_id") as string);
  }

  get selectedFacilities(): number[] {
    return JSON.parse(localStorage.getItem("selected_facilities") as string);
  }

  setUser(user: UserDTO) {
    localStorage.setItem("auth_token", user.authToken);
    localStorage.setItem("id", user.id.toString());
  }

  setAccount(availableAccount: AvailableAccount) {
    localStorage.setItem("account_id", availableAccount.accountID.toString());
  }

  setApp(app: AccountAppDTO) {
    localStorage.setItem("app_id", app.id.toString());
  }

  setSelectedFacilities(selectedFacilities: FacilityDTO[]) {
    const selectedFacilitiesArr = selectedFacilities.map(
      (facility) => facility.id,
    );
    localStorage.setItem(
      "selected_facilities",
      JSON.stringify(selectedFacilitiesArr),
    );
  }

  clearSelectedFacilities() {
    localStorage.removeItem("selected_facilities");
  }

  clearUser() {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("id");
    this.clearAccount();
  }

  clearAccount() {
    localStorage.removeItem("account_id");
    this.clearApp();
  }

  clearApp() {
    localStorage.removeItem("app_id");
  }

  set customerRosterColumns(columns: any){
    localStorage.setItem("custRostCols2" + this.accountID, JSON.stringify(columns));
  }

  get customerRosterColumns(): any {
    return JSON.parse(localStorage.getItem("custRostCols2" + this.accountID) as string);
  }

  set pageSize(pageSize: number) {
    localStorage.setItem("page_size", pageSize.toString());
  }

  get pageSize(): number {
    return Number.parseInt(localStorage.getItem("page_size") as string);
  }

  /**
   * Guided setup flag for a given account. Stored per-account so that
   * guided setup can be enabled or disabled independently.
   */
  setGuidedSetupEnabled(accountID: number, enabled: boolean) {
    localStorage.setItem(
      `guided_setup_${accountID}`,
      enabled ? "1" : "0",
    );
  }

  isGuidedSetupEnabled(accountID: number): boolean {
    return localStorage.getItem(`guided_setup_${accountID}`) === "1";
  }

  setPage(component: string, accountID: number, appID: number, page: number) {
    localStorage.setItem(component + '-' + accountID.toString() + '-' + this.appID.toString() + 'Page', page.toString());
  }

  getPage(component: string, accountID: number, appID: number,): number {
    return Number.parseInt(localStorage.getItem(component + '-' + accountID.toString() + '-' + appID.toString() + 'Page') as string);
  }

  setObject(name: string, accountID: number, appID: number, collection: any) {
    //console.log('setObject', collection);
    localStorage.setItem(name + '-' + accountID.toString() + '-' + appID.toString(), JSON.stringify(collection));
  }

  getObject(name: string, accountID: number, appID: number,) {
    let rawObj = localStorage.getItem(name + '-' + accountID.toString() + '-' + appID.toString())
    //console.log('getObject', rawObj);
    if(rawObj === null || rawObj === undefined || rawObj === 'undefined'){
      return null;
    }
    return JSON.parse(rawObj as string);
  }

  clear() {
    localStorage.clear();
  }
}
